import { z } from "zod";
import { validators } from "./primitives";

export const addressFields = {
  line1: validators.line1.required(),
  line2: validators.line2.optional(),
  city: validators.city.required(),
  state: validators.state.required(),
  postalCode: validators.postalCode.required(),
  country: validators.country.required().default("US"),
};

export const addressSchema = z.object(addressFields);
export type Address = z.infer<typeof addressSchema>;

export const addressWithCoordsSchema = addressSchema.extend({
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});
export type AddressWithCoords = z.infer<typeof addressWithCoordsSchema>;

export const addressTypes = ["shipping", "billing", "other"] as const;
export type AddressType = (typeof addressTypes)[number];

export const addressWithTypeSchema = addressSchema.extend({
  type: z.enum(addressTypes),
});
export type AddressWithType = z.infer<typeof addressWithTypeSchema>;

export const emptyAddress: Address = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "US",
};
